import { factory } from "../../../../utils/apiThunkFactory";

export const getActiveInvites = factory.get("inviteModal/getActiveInvites", "/api/guestManagment/invitations");

export const deactivateInvite = factory.put("inviteModal/deactivateInvite","/api/guestManagment/invitations/deactivate/:id");

export const deactivateInvitationByAvatarId = factory.put("inviteModal/deactivateInvitationByAvatarId","/api/guestManagment/invitations/deactivate-by-avatar/:id");

export const addGuest =  factory.post("inviteModal/addGuest", '/api/guestManagment/add');

export const sendEmail = factory.post("inviteModal/sendEmail", "/api/users/send-email");

export const findGuestTokenByEmail = factory.get("inviteModal/findGuestTokenByEmail", "/api/guest/invitations/byemail/:email" ) ;

export const generateStaticDemoLink = factory.post("inviteModal/generateStaticDemoLink","/api/guest/generate-link");

export const resendInvitation = factory.post("inviteModal/resendInvitation","/api/guestManagment/invitations/resend/:id");